import { render, staticRenderFns } from "./fpDownloadPw.vue?vue&type=template&id=0b7dba1c&"
import script from "./fpDownloadPw.vue?vue&type=script&lang=js&"
export * from "./fpDownloadPw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports